import React, { useEffect, useRef } from "react"; // useState hata diya
import DOMPurify from "dompurify";

const HeroSection = ({ data, popup }) => {
  const videoRef = useRef(null);

  // NOTE: IntersectionObserver wala logic Hero section ke liye hata diya hai
  // kyunke iPhone delayed video load ko autoplay nahi karne deta.
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // 1. React ko bypass kar ke seedha attributes set karein
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.setAttribute("muted", "");
    video.muted = true; // JS property

    // 2. Video play karne ki koshish karein
    const attemptPlay = async () => {
      try {
        await video.play();
      } catch (error) {
        console.log("Autoplay prevented:", error);
        // Agar autoplay fail ho, to user ke touch ka wait karein
        // Body pe kahin bhi click hone par video chala dein (Fallback)
        document.body.addEventListener(
          "touchstart",
          () => {
            if (video.paused) video.play();
          },
          { once: true }
        );
      }
    };

    // Thora sa wait kar ke play karein (Safety delay)
    setTimeout(() => {
      attemptPlay();
    }, 100);
  }, [data]);
  if (!data) return null;
  const userAgent = navigator.userAgent;
  return (
    <div className="hero_sec">
      {!(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) &&
      data.background_video ? (
        <video
          ref={videoRef}
          className="hero_bg_video"
          // HTML attributes hardcode kar rahe hain
          playsInline
          webkit-playsinline="true"
          autoPlay
          muted
          loop
          preload="auto" // Metadata ki jagah auto kar dein
          poster={data.poster_image}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        >
          <source
            src={data.background_video}
            type={
              data.background_video.includes(".webm") // .endsWith kabhi kabhi query params ki waja se fail hota hai
                ? "video/webm"
                : "video/mp4"
            }
          />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          src="https://47.activ8.digital/wp-content/uploads/2025/12/Adobe-Express-dataskycenter-1-2.gif"
          alt="hero-section-banner-image"
          className="hero-section-mob-image"
        />
      )}

      <div className="hero_content">
        {data.main_heading && (
          <h1
            className="hero_sec_heading"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(data.main_heading),
            }}
          />
        )}
        {data.paragraph && (
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(data.paragraph),
            }}
          />
        )}
        {data.right_button_text && (
          <div className="hero_buttons">
            <a className="white_btn" onClick={() => popup(true)} type="button">
              {data.right_button_text}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroSection;
